import React from "react";
import "./styles.css";
function MenuItem({ text, overlayColor, imageUrl }) {
  return (
    <div className="promo" style={{ overlayColor }}>
      <h2 className="menu-item-title">{text}</h2>
      <div className="image-wrapper">
        <img src={imageUrl} alt="" />
      </div>
    </div>
  );
}

export default MenuItem;
